import { CartDetails } from 'entities/cart-details';

export class AppInsightPartSearch {
    userId: string = '';
    rewardNumber: string = '';
    branchNumber: string = '';
    searchTerm: string = '';
    source: string = '';
    cartDetails: CartDetails;
    results: string = '';
    plMetricName: string = '';
}